module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACQSURBVHgBxdTBDYAgDAXQFhZwBDdTT6zhFgQuxEmcyQEIQuJRLYUa/wVCyEsIHwD+jvd+d85N1D4FjMQYlzysFIzAjLV2VErtBTfGbCJoDdyEUnAz+gZ3oU9wN3oH47VAdo8KIo4ppTlPZ1ZPK3N8c3zojPhFiVdKvPziz1T8Q6kBS1g91VoHCmQnhDDU7DsBPSlX1F7HgwIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/goto.png
// module id = +tdO
// module chunks = 1